"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginationQuerySchema = void 0;
const zod_1 = require("zod");
/**
 * Shared pagination + search query schema, used by every `GET /<resource>`
 * list endpoint. `page`/`pageSize` are coerced from the string query params
 * Express hands us; `search` is a free-text filter (matched against
 * resource-specific fields by each service).
 */
exports.paginationQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number('Pagina trebuie să fie un număr.').int().min(1, 'Pagina trebuie să fie cel puțin 1.').default(1),
    pageSize: zod_1.z.coerce
        .number('pageSize trebuie să fie un număr.')
        .int()
        .min(1, 'pageSize trebuie să fie cel puțin 1.')
        .max(100, 'pageSize nu poate depăși 100.')
        .default(20),
    search: zod_1.z.string().trim().optional(),
});
